import React, { Component } from 'react';

class Error extends Component {
  render() {
    return <div>404 Page Not Found</div>;
  }
}

export default Error;
